import { Formik, Form, Field } from "formik";
import Select from "react-select";
import { CircularProgress } from "@mui/material";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Country, State, City } from "country-state-city";

const DoctorDetailsForm = ({
  initialValues,
  doctorDetailsSchema,
  doctorTypeOption,
  handleSubmit,
  isSubmitting,
  stateList,
  cityList,
  selectedCountry,
  selectedState,
  selectedCity,
  setSelectedCountry,
  setSelectedState,
  setSelectedCity,
  hospitalList,
  specialityList,
  isUploading,
  uploadImageHandler,
  documentCertificate,
  handleButtonClick,
  setViewImage,
  fileInputRef,
}) => (
  <Formik
    initialValues={initialValues}
    validationSchema={doctorDetailsSchema}
    onSubmit={handleSubmit}
    validateOnChange
    validateOnBlur={false}
  >
    {({ errors, touched, setFieldValue }) => (
      <Form>
        <div className="w-full grid grid-cols-3 gap-4">
          {/* Full Name */}
          <label className="label1">
            <div className="text-content">
              Full Name <span className="required">*</span>
            </div>
            <Field
              type="text"
              className="input-field"
              name="fullName"
              placeholder="Enter Full Name"
            />
            {touched.fullName && errors.fullName && (
              <div className="field-error">{errors.fullName}</div>
            )}
          </label>

          {/* Registration Number */}
          <label className="label1">
            <div className="text-content">Registration Number</div>
            <Field
              type="text"
              className="input-field"
              name="registrationNumber"
              placeholder="Enter Registration Number"
              maxLength="10"
            />
            {touched.registrationNumber && errors.registrationNumber && (
              <div className="field-error">{errors.registrationNumber}</div>
            )}
          </label>

          {/* Doctor Type */}
          <label className="label1">
            <div className="text-content">
              Doctor Type <span className="required">*</span>
            </div>
            <Select
              name="doctorType"
              options={doctorTypeOption}
              getOptionLabel={(o) => o.label}
              getOptionValue={(o) => o.value}
              onChange={(item) => setFieldValue("doctorType", item.value)}
              placeholder="Select Doctor type"
            />
            {touched.doctorType && errors.doctorType && (
              <div className="field-error">{errors.doctorType}</div>
            )}
          </label>

          {/* Email */}
          <label className="label1">
            <div className="text-content">Email ID</div>
            <Field
              className="input-field"
              name="email"
              placeholder="Enter email address"
            />
            {touched.email && errors.email && (
              <div className="field-error">{errors.email}</div>
            )}
          </label>

          {/* Phone */}
          <label className="label1">
            <div className="text-content">Phone</div>
            <Field
              type="number"
              className="input-field"
              name="phone"
              placeholder="Enter phone number"
            />
            {touched.phone && errors.phone && (
              <div className="field-error">{errors.phone}</div>
            )}
          </label>

          {/* Gender */}
          <label className="label1">
            <div className="text-content">
              Gender <span className="required">*</span>
            </div>
            <Field className="input-field" name="gender" as="select">
              <option value="">Select Gender</option>
              <option value="MALE">MALE</option>
              <option value="FEMALE">FEMALE</option>
              <option value="OTHER">OTHER</option>
            </Field>
            {touched.gender && errors.gender && (
              <div className="field-error">{errors.gender}</div>
            )}
          </label>

          {/* DOB */}
          <label className="label1">
            <div className="text-content">Date Of Birth</div>
            <Field
              className="input-field"
              name="birthDate"
              type="date"
              max={new Date().toISOString().split("T")[0]}
            />
            {touched.birthDate && errors.birthDate && (
              <div className="field-error">{errors.birthDate}</div>
            )}
          </label>

          {/* Country */}
          <label className="label1">
            <div className="text-content">Country</div>
            <Select
              options={Country.getAllCountries()}
              getOptionLabel={(o) => o.name}
              getOptionValue={(o) => o.name}
              value={selectedCountry}
              onChange={(item) => {
                setSelectedCountry(item);
                setFieldValue("country", item.name);
              }}
              placeholder="Select Country"
            />
            {touched.country && errors.country && (
              <div className="field-error">{errors.country}</div>
            )}
          </label>

          {/* State */}
          <label className="label1">
            <div className="text-content">State</div>
            <Select
              options={stateList}
              getOptionLabel={(o) => o.name}
              getOptionValue={(o) => o.name}
              value={selectedState}
              onChange={(item) => {
                setSelectedState(item);
                setFieldValue("state", item.name);
              }}
              placeholder="Select State"
            />
            {touched.state && errors.state && (
              <div className="field-error">{errors.state}</div>
            )}
          </label>

          {/* City */}
          <label className="label1">
            <div className="text-content">City</div>
            <Select
              options={cityList}
              getOptionLabel={(o) => o.name}
              getOptionValue={(o) => o.name}
              value={selectedCity}
              onChange={(item) => {
                setSelectedCity(item);
                setFieldValue("city", item.name);
              }}
              placeholder="Select City"
            />
            {touched.city && errors.city && (
              <div className="field-error">{errors.city}</div>
            )}
          </label>

          {/* Address */}
          <label className="label1">
            <div className="text-content">Address Line 1</div>
            <Field
              className="input-field"
              name="address"
              placeholder="Address Line 1"
            />
            {touched.address && errors.address && (
              <div className="field-error">{errors.address}</div>
            )}
          </label>

          {/* Pincode */}
          <label className="label1">
            <div className="text-content">Pincode</div>
            <Field
              type="number"
              className="input-field"
              name="pincode"
              placeholder="Enter Pincode"
            />
            {touched.pincode && errors.pincode && (
              <div className="field-error">{errors.pincode}</div>
            )}
          </label>

          {/* Qualification */}
          <label className="label1">
            <div className="text-content">Highest Qualification</div>
            <Field
              className="input-field"
              name="highestQualification"
              placeholder="Highest Qualification"
            />
            {touched.highestQualification && errors.highestQualification && (
              <div className="field-error">{errors.highestQualification}</div>
            )}
          </label>

          {/* Hospital */}
          <label className="label1">
            <div className="text-content">
              Hospital name <span className="required">*</span>
            </div>
            <Select
              options={hospitalList}
              getOptionLabel={(o) => o.name}
              getOptionValue={(o) => o.id}
              onChange={(item) => setFieldValue("hospitalId", item.id)}
              placeholder="Select Hospital"
            />
            {touched.hospitalId && errors.hospitalId && (
              <div className="field-error">{errors.hospitalId}</div>
            )}
          </label>

          {/* Speciality */}
          <label className="label1">
            <div className="text-content">Speciality name</div>
            <Select
              isMulti
              options={specialityList}
              getOptionLabel={(o) => o.speciality}
              getOptionValue={(o) => o.id}
              onChange={(items) => {
                const selectedIds = items.map((item) => item.specialityId);
                setFieldValue("specialityIds", selectedIds);
              }}
              placeholder="Select Speciality"
            />
            {touched.specialityIds && errors.specialityIds && (
              <div className="field-error">{errors.specialityIds}</div>
            )}
          </label>

          {/* From Date */}
          <label className="label1">
            <div className="text-content">From Date</div>
            <Field
              className="input-field"
              name="fromDate"
              type="date"
              max={new Date().toISOString().split("T")[0]}
            />
            {touched.fromDate && errors.fromDate && (
              <div className="field-error">{errors.fromDate}</div>
            )}
          </label>

          {/* Certificate */}
          <label className="label1">
            <div className="text-content">Registration Certificate</div>
            <div className="flex items-end gap-4">
              {documentCertificate && (
                <img
                  src={documentCertificate}
                  alt="registration certificate"
                  className="w-[60px] h-[80px] cursor-zoom-in"
                  onClick={() => setViewImage(true)}
                />
              )}
              <div
                style={{ border: "1px solid #017C57" }}
                className={`flex items-center gap-2 px-5 py-3 bg-white font-semibold rounded-full text-[#017C57] 
    ${isUploading ? "opacity-60 cursor-not-allowed" : "cursor-pointer"}`}
                onClick={!isUploading ? handleButtonClick : null}
              >
                {isUploading ? (
                  <CircularProgress size={18} />
                ) : (
                  <FileUploadOutlinedIcon fontSize="small" />
                )}

                {isUploading
                  ? "Uploading..."
                  : documentCertificate
                  ? "Re-Upload Document"
                  : "Upload Document"}
              </div>
            </div>
          </label>
        </div>

        <div className="flex justify-center mt-12">
          {isSubmitting ? (
            <CircularProgress />
          ) : (
            <button
              type="submit"
              className="text-sm font-thin text-white bg-[#017C57] py-2 px-4  rounded-full border-none cursor-pointer"
            >
              Save Details
            </button>
          )}
        </div>

        <input
          type="file"
          onChange={uploadImageHandler}
          style={{ display: "none" }}
          ref={fileInputRef}
          accept=".jpg,.jpeg,.png"
        />
      </Form>
    )}
  </Formik>
);

export default DoctorDetailsForm;
